import React from 'react';
import { useParams } from 'react-router-dom';
import WindowForm from '../components/WindowForm';

const CreateWindowPage: React.FC = () => {
  const { listingId } = useParams<{ listingId: string }>();

  if (!listingId) {
    return <div className="text-center py-8">Listing ID not found</div>;
  }

  return (
    <div className="max-w-3xl mx-auto">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">Create Rental Window</h1>
      <WindowForm mode="create" listingId={listingId} />
    </div>
  );
};

export default CreateWindowPage;

